<template>
    <asset-editor @save="onSave" :is-saving="isSaving" />
</template>

<script>
import AssetEditor from '@/components/assets/AssetEditor';
import { mapGetters } from 'vuex'

export default {
    components: {
        AssetEditor
    },
    created() {
        this.$store.dispatch('setPageTitle', 'Create Asset');  
	},
    computed: {
        ...mapGetters({
            isSaving: 'assets/isSaving'
        })
    },
    methods: {
        async onSave(payload) {

            const result = await this.$store.dispatch('assets/create', payload);
            if (result.isSuccess) {
                
            }
        }
    }
}

</script>